import angular from 'angular'
import moment from 'moment-timezone'

const NO_DATE = '–'

/**
 * Filter the given date/time in the specified format in the specified time zone.
 *
 * @param  input
 *         The date/time to format
 *
 * @param  [format]
 *         The format to use - see moment.js docs for applicable formats
 *
 * @param  [timeZone]
 *         The time zone to display the date/time in
 *
 * @return The formatted date/time
 */
export function dateFormat(
  input: string | Date | null | undefined,
  format = 'ddd, D MMM YYYY, h:mma',
  timeZone?: string
) {
  if (!input) {
    return NO_DATE
  }

  const date = moment(input)

  if (timeZone) {
    date.tz(timeZone)
  }

  return date.format(format)
}

/**
 * Filter for formatting dates and times.
 *
 * @module webregister.filters.wrDateFormat
 */
angular.module('webregister.filters').filter('wrDateFormat', () => dateFormat)
